import DashboardType from '../../../entities/DashboardType.js';
import DashboardView from '../../../entities/DashboardView.js';
import ActivixDate from '../../../value-objects/ActivixDate.js';
import { useContextStore } from '../context/store.js';
import { useGlobalStore } from '../../store.js';

export default {
    division() {
        const dashboardType = this.dashboardType;
        let tmpDivision;

        if (empty(dashboardType)) {
            return [];
        }

        if (dashboardType == 'service') {
            return ['service'];
        }

        if (!empty(this.configs.filters)) {
            tmpDivision = this.configs.filters['division:name'];
        }

        if (empty(tmpDivision)) {
            return [];
        }

        return tmpDivision;
    },

    dashboardDisabledForGroups() {
        const groupIsSelected = !!useContextStore().group.id;
        const parentAccountIsSelected = useContextStore().account.account_manager;

        if (!groupIsSelected && !parentAccountIsSelected) {
            return false;
        }

        if ([DashboardType.SALE, DashboardType.EVENT].includes(this.dashboardType)) {
            return true;
        }

        if ([DashboardType.ACTIVITY].includes(this.dashboardType) && groupIsSelected) {
            return true;
        }

        return false;
    },

    getDashboardView() {
        return (viewId) => {
            for (const views of Object.values(this.dashboardViews)) {
                const view = views.find(v => v.id == viewId);

                if (view) {
                    return view;
                }
            }

            return {};
        };
    },

    dashboardView() {
        if (
            this.selectedDashboardView &&
            this.selectedDashboardView.dashboard == this.dashboardType &&
            (
                this.selectedDashboardView.user_id == useGlobalStore().parentAuthUser.id ||
                this.selectedDashboardView.is_shared
            )
        ) {
            if (this.notificationDate) {
                this.selectedDashboardView.filter.renewal_alert_date = new ActivixDate(
                    this.notificationDate,
                ).toHumanShort(false);
            }

            return new DashboardView(this.selectedDashboardView);
        }

        return new DashboardView();
    },

    dashboardCriteria() {
        return {
            accountId: useContextStore().accountId,
            dashboard: this.dashboardType,
            divisions: this.division,
            startDate: new ActivixDate(this.startDate).startOfDay().toDateTimeString(),
            endDate: new ActivixDate(this.endDate).endOfDay().toDateTimeString(),
            filteredCampaigns: this.filteredCampaigns,
            filteredDates: this.filteredDates,
            filters: this.activeDashboardFilters,
            groupId: useContextStore().groupId || undefined,
            options: this.configs.options,
            orderBy: this.pagination.orderBy,
            sortBy: this.pagination.sortBy,
            userId: useContextStore().userId || undefined,
            teamId: useContextStore().teamId || undefined,
        };
    },

    activeDashboardFilters() {
        return Object.keys(this.configs.filters)
            .filter(name => {
                return this.configs.columnVisibilities[name] == 'visible' ||
                    this.configs.columns[name]?.visible && this.configs.columnVisibilities[name] !== 'hidden';
            })
            .reduce((filters, key) => {
                const value = this.configs.filters[key];

                if (empty(value)) {
                    return filters;
                }

                filters[key] = value;

                return filters;
            }, {});
    },

    isMassMailing() {
        if (this.allLeadsInTableSelected) {
            return true;
        }

        return this.bulkSelect.filter(lead => !!lead.emails.length).length > 1;
    },
};
